import { render, staticRenderFns } from "./SlottedMessageInDrawer.vue?vue&type=template&id=6b3b579e&scoped=true&"
import script from "./SlottedMessageInDrawer.vue?vue&type=script&lang=js&"
export * from "./SlottedMessageInDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SlottedMessageInDrawer.vue?vue&type=style&index=0&id=6b3b579e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b579e",
  null
  
)

export default component.exports